<template>
    <div v-if="headerMenuItems.length" class="custom-header-menu d-flex justify-content-end flex-wrap flex-md-nowrap">
        <ul class="navbar-nav">
            <li
                v-for="item in headerMenuItems"
                :key="item.id"
                class="nav-item"
                :class="{ 'dropdown': hasChildren(item), 'active': activeDropdown === item.id }"
            >
                <template v-if="!hasChildren(item)">
                    <a
                        :href="item.url"
                        :target="item.target === 'New Window' ? '_blank' : ''"
                        class="nav-link"
                        tabindex="1"
                        @click="clearActiveItems"
                    >{{ item.name }}<span v-if="item.name === 'Messages' && messageCount" class="badge" tabindex="2">{{ messageCount }}</span>
                    </a>
                </template>
                <template v-else>
                    <div v-menu-click-outside:[item]="closeDropdown" :data-active="activeDropdown === item.id">
                        <a
                            @click.prevent="toggleDropdown(item.id)"
                            class="nav-link dropdown-toggle"
                            href="#"
                            tabindex="3"
                        >
                            {{ item.name }}
                            <span class="dropdown-icon"></span>
                        </a>
                        <div class="dropdown-menu" :class="{ 'show': activeDropdown === item.id }">
                            <template v-for="(child, key) in item.children">
                                <a
                                    v-if="child.name === 'Sign Out'"
                                    :key="child.id"
                                    href="/logout"
                                    class="dropdown-item"
                                    :title="child.tooltip || ''"
                                    :tabindex="4 + key"
                                >
                                    Sign Out
                                </a>
                                <a
                                    v-else
                                    :href="child.url"
                                    :target="child.target === 'New Window' ? '_blank' : ''"
                                    :key="child.id"
                                    class="dropdown-item"
                                    :title="child.tooltip || ''"
                                    :tabindex="4 + key"
                                    @click="handleItemClick"
                                >
                                    {{ child.name }}
                                </a>
                            </template>
                        </div>
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'HeaderMenuComponent',
    data() {
        return {
            vueLoaded: false
        }
    },
    mounted() {
        this.vueLoaded = true;

        const staticHeader = document.getElementById('static-header');
        if (staticHeader) staticHeader.style.display = 'none';

        const vueHeader = document.getElementById('vue-header');
        if (vueHeader) vueHeader.style.display = 'block';

        this.openMenuItemRelatedToRoute();
    },
    directives: {
        "menu-click-outside": {
            update: function (el, binding, vnode) {
                el.clickOutsideEvent = (event) => {
                    if (!(el === event.target || el.contains(event.target)) && el.dataset?.active) {
                        vnode.context[binding.expression](event, {...binding.arg});
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            },
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            activeDropdown: state => state.navigation.activeDropdown,
        }),
        ...mapGetters('user', ['isAuthenticated']),
        headerMenuItems() {
            return this.user?.menus?.find(menu => menu.name === 'Header Menu')?.items || [];
        },
        messageCount() {
            return this.user?.alerts_count || 0;
        },
    },
    methods: {
        ...mapActions('navigation', ['setActiveDropdown']),
        toggleDropdown(itemId) {
            this.setActiveDropdown(this.activeDropdown === itemId ? null : itemId);
        },
        closeDropdown(e, args) {
            if(this.activeDropdown === args.id) {
                this.setActiveDropdown(null);
            }
        },
        hasChildren(item) {
            return item.children && item.children.length > 0;
        },
        async signOut() {
            try {
                const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                await fetch('/logout', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                    },
                    body: JSON.stringify({})
                });
                window.location.href = '/login';
            } catch (error) {
                console.error('Logout failed', error);
            }
        },
        clearActiveItems() {
            const activeItems = document.querySelectorAll('.custom-header-menu .hover');
            activeItems.forEach(item => item.classList.remove('hover'));
        },
        handleItemClick(event) {
            this.clearActiveItems();
            event.target.classList.add('hover');
        },
        openMenuItemRelatedToRoute() {
            this.clearActiveItems();

            const currentPathname = window.location.pathname.replace(/\/+$/, "");
            const currentSegments = currentPathname.split('/');

            this.headerMenuItems.forEach((item) => {
                if (this.hasChildren(item)) {
                    item.children.forEach((child) => {
                        const childUrl = new URL(child.url, window.location.origin);
                        const childSegments = childUrl.pathname.replace(/\/+$/, "").split('/');

                        if (this.compareSegments(currentSegments, childSegments)) {
                            this.$nextTick(() => {
                                const menuItem = document.querySelector(`.custom-header-menu .dropdown-item[href="${child.url}"]`);
                                if (menuItem) menuItem.classList.add('hover');
                            });
                        }
                    });
                }
            });
        },
        compareSegments(currentSegments, menuSegments) {
            if (currentSegments.length !== menuSegments.length) return false;
            return currentSegments.every((segment, index) => segment === menuSegments[index]);
        }
    }
};
</script>
<style lang="scss" scoped>
.custom-header-menu {
    .nav-link.hover,
    .dropdown-item.hover {
        background: #F1F6FB;
        color: #1169B1 !important;
        border-radius: 10px;
    }
}
</style>
